import { IntegrityMonitorRuleSetFormController } from '../controller/IntegrityMonitorRuleSetFormController';
import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { IntegrityMonitorRuleGridItem } from '../../integrityMonitorRulesGrid/types';

export class IntegrityMonitorRuleSetFormWebComponent extends BaseWebComponentElement {
  private rulesRef?: Array<IntegrityMonitorRuleGridItem>;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: IntegrityMonitorRuleSetFormController,
    });
  }

  get isVisible(): boolean | undefined {
    if (this.hasAttribute('data-is-visible')) {
      const value = this.getAttribute('data-is-visible');
      return value ? JSON.parse(value) : undefined;
    }

    return undefined;
  }

  set isVisible(value: boolean | undefined) {
    if (value) {
      this.setAttribute('data-is-visible', '');
    } else {
      this.removeAttribute('data-is-visible');
    }
  }

  get ruleSetId(): string | undefined {
    if (this.hasAttribute('data-rule-set-id')) {
      const value = this.getAttribute('data-rule-set-id');
      return value ?? '';
    }

    return undefined;
  }

  set ruleSetId(value: string | undefined) {
    if (typeof value === 'undefined') {
      this.removeAttribute('data-rule-set-id');
    } else {
      this.setAttribute('data-rule-set-id', value);
    }
  }

  get rules(): Array<IntegrityMonitorRuleGridItem> | undefined {
    return this.rulesRef;
  }

  set rules(value: Array<IntegrityMonitorRuleGridItem> | undefined) {
    this.rulesRef = value;
  }
}
